import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';
import { useIsMobileLayout } from '../../hooks';

import theme from '../../config/theme/theme';

import Box from '../Styled/Box';
import Typography from '../Typography/Typography';

const ProgressBar = ({
  percentage,
  initialTime,
  timeRef,
  timerDisabled,
}) => {
  const isMobile = useIsMobileLayout();
  const { formatMessage: f } = useIntl();

  const [timer, setTimer] = useState(initialTime);

  useEffect(() => {
    if (timeRef) {
      // eslint-disable-next-line no-param-reassign
      timeRef.current = timer;
    }
  }, [timeRef, timer]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!timerDisabled) {
        setTimer(timer + 1);
      }
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [timer, timerDisabled]);

  return (
    <Box
      id='progress-bar-background'
      position='fixed'
      top='60px'
      left={0}
      zIndex={1000}
      width='100%'
      py='12px'
      px={isMobile ? '24px' : 0}
      bg='white'
      boxShadow={theme.shadows.light[3]}
    >
      <Box id='progress-bar-items' maxWidth='848px' margin='auto'>
        <Box id='progress-bar-text' display='flex' justifyContent='space-between'>
          <Box display='flex'>
            <Typography variant='buttonSM' color='coldgrey700'>
              {`${percentage}%`}
            </Typography>

            <Typography ml='4px' variant='helper' color='coldgrey700'>
              {f({ id: 'words.plurals.answered' }, { num: 1 }).toLocaleLowerCase()}
            </Typography>
          </Box>
        </Box>

        <Box id='progress-bar-bars' mt='6px' position='relative'>
          <Box
            id='grey'
            bg='coldgrey400'
            borderRadius='12px'
            height='14px'
            width='100%'
          />

          <Box
            id='color'
            bg={Number(percentage) === 100 ? 'teal' : 'purple100'}
            borderRadius='12px'
            position='absolute'
            top={0}
            zIndex={1}
            height='14px'
            width={`${percentage}%`}
          />
        </Box>
      </Box>
    </Box>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.node,
  initialTime: PropTypes.node,
  timeRef: PropTypes.shape({ current: PropTypes.node }),
  timerDisabled: PropTypes.bool,
};

ProgressBar.defaultProps = {
  percentage: 0,
  initialTime: 0,
  timeRef: null,
  timerDisabled: false,
};

export default ProgressBar;
